import React from 'react'
import styled from 'styled-components'
import Picture from './picture'
import propTypes from 'prop-types'
import { Divider } from '@material-ui/core'
import ButtonBase from '../../../components/link'
// import InputQuiantity from '../../components/input_quantity'
import Currency from '../../../helpers/currency'

const Data = props => {
  const process = props.process ? props.process.filter(step => !!step) : []

  return (
    <ItemContent>
      <PictureBox>
        <Picture
          pictures={[props.picture, ...props.pictures]}
        />
      </PictureBox>
      <DataBox>
        <Header>
          <Title>{props.title}</Title>
          <Price>$ {Currency.formatMoney(props.price)}</Price>
        </Header>
        <Divider />
        <DescriptionWithoutLineHeight>
          <div>Descripción</div>
          <article dangerouslySetInnerHTML={{ __html: props.description }} />
        </DescriptionWithoutLineHeight>
        <Divider />
        {props.indications && (
          <>
            <Description>
              <div>Indicaciones</div>
              <article dangerouslySetInnerHTML={{ __html: props.indications }} />
            </Description>
            <Divider />
          </>
        )}
        {process && !!process.length && (
          <>
            <Description>
              <div>Procedimiento</div>
              <ol>
                {process && process.map((step, index) => (
                  <li style={{ marginBottom: '15px' }} key={index}>{step}</li>
                ))}
              </ol>
            </Description>
            <Divider />
          </>
        )}
        <Divider />
        <Notify>
          <IconContainer>i</IconContainer>
          Para tu mayor comodidad, puedes elegir que la toma de tu estudio sea a domicilio o si prefieres en nuestra sucursal.
        </Notify>
        <ButtonContainer>
          <Button to='/' variant='outlined'>Seguir comprando</Button>
          <Button handleClick={props.AddToCart} variant='contained'>Agregar al carrito</Button>
        </ButtonContainer>
      </DataBox>
    </ItemContent>
  )
}

Data.propTypes = {
  picture: propTypes.string,
  pictures: propTypes.array,
  description: propTypes.string,
  price: propTypes.number,
  title: propTypes.string,
  AddToCart: propTypes.func,
  indications: propTypes.string,
  process: propTypes.array
}

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px 0px;
`
const Button = styled(ButtonBase)`
  width: 48%;
  font-size: 1em;
  padding: 10px 0px;
  border-radius: 5px;
  color: ${props => props.variant === 'contained' ? '#fff' : 'firs'};
  border: ${props => props.variant === 'contained' ? '' : '1px solid var(--first)'};
  background: ${props => props.variant === 'contained' ? 'var(--first)' : 'none'};
  @media screen and (max-width:700px) {
    font-size: 1em;
  }
`

const ItemContent = styled.div`
  max-width: 1200px;
  margin: auto;
  background-color: var(--background-secondary);
  border-radius: 5px;
  padding: 50px 20px;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  @media screen and (max-width:700px) {
    max-width: 550px;
    margin: auto;
    padding: 0px;
  }
`
const PictureBox = styled.div`
  padding: 10px;
  width: 60%;
  @media screen and (max-width:900px) {
    width: 50%
  }
  @media screen and (max-width:700px) {
    width: 100%;
    padding: 0px;
  }
`
const DataBox = styled.div`
  padding: 10px;
  width: 40%;
  @media screen and (max-width:900px) {
    width: 50%
  }
  @media screen and (max-width:700px) {
    width: 100%;
    padding: 20px;
  }
`
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const Title = styled.h1`
  margin-right: 20px;
  font-size: 1.3em;
  color: var(--second);
  font-weight: bold;
`
const Price = styled.h1`
  font-size: 1.3em;
  min-width: 100px;
`
const Description = styled.div`
  /* * {
    font-size: 1.2rem!important
  } */
  font-size: 1.2em;
  padding: 10px 0px;
  & li::before {
    color: red
  }
  & div {
    color: var(--first);
    font-weight: bold;
    margin-bottom: 10px;
  }
`
const DescriptionWithoutLineHeight = styled(Description)`
  p, li {
    line-height: initial!important;
  }
`
const Notify = styled.div`
  padding: 30px;
  color: var(--first);
  font-size: 1em;
  font-weight: bold;
  background: #cdcdcd2e;
  margin-top: 29px;
  border-radius: 10px;
  position: relative;
`
const IconContainer = styled.div`
  position: absolute;
  padding: 2px 16px;
  background: #ffba54;
  border-radius: 10px;
  font-size: 25px;
  color: #fff;
  border: 3px solid #fff;
  top: -13px;
  left: -17px;
`

// const Cuantity = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   font-size: 1.5em;
//   font-weight: bold;
//   padding: 10px 0px;
// `

export default Data
